export const MENUS = {
    ALL_FORM: {
        label: "All Forms",
        link: ""
    }
};
